// extracted by mini-css-extract-plugin
export default {"card":"index_card__dJHt2","item":"index_item__XroDk","label":"index_label__6M-3o","yellow":"index_yellow__kmwe+","green":"index_green__FQ2QF","num":"index_num__n9ib+"};